import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const settings = ['내정보', '로그아웃'];
function Top(props :any) {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  
  
  return (

    <AppBar position="fixed" sx={{background:'#fff', boxShadow:'none', borderBottom:'1px solid #ccc',}}>
      <Container sx={{p:0}}>
        <Toolbar sx={{width:'100%', display:'flex', 
              p: { xs: 0, md:0}}}>
          {/* <IconButton onClick={handleOpen}>
           <ArrowBackOutlinedIcon />
          </IconButton>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={open}
              onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop> */}
          
          <Typography
            noWrap
            textAlign="center"
            sx={{
              ml: props.title === '회원 가입' ? '65px' : '',
              display: { xs: 'flex',  },
              flexGrow: 1,
              fontWeight: 700,
              color: '#555',
              textDecoration: 'none',
              justifyContent:'center',
              fontSize:'18px',
            }}
          >
            {props.title}
          </Typography>
          {
            props.title === '회원 가입'
              ? <Button sx={{ fontSize: 18, fontWeight: 700, color: '#777' }} onClick={() => navigate('/login')}>
                X
              </Button>
              : null
          }

          {/* <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', mr: 1, color: '#777' }} onClick={console.log(123)}>X</Typography> */}

          {/* <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 , mr: 2,}}>
                <AccountCircleRoundedIcon />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Top;